import React, { useCallback, useEffect, useState } from 'react';

import {
   Input,
} from 'reactstrap';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import withInputErrorMessage from '../withInputErrorMessage';

const EmailInput = (props) => {
   return (
      <Input
         type='email'
         name={ props.name }
         onChange={ props.onChange }
         onBlur={ props.onBlur }
         disabled={ props.isDisabled }
         placeholder={ props.placeholder }
         bsSize={props.bsSize}
         className={props.className}
         value={props.value}
      />
   );
};

EmailInput.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   bsSize: PropTypes.string,
   placeholder: PropTypes.string,
   className: PropTypes.string,
};

EmailInput.defaultProps = {
   value: '',
   isDisabled: false,
   bsSize: 'sm',
   placeholder: 'Enter your email',
   className: '',
};

const withEmailInput = (EmailInputComponent) => {
   const WrappedComponent = (props) => {
      const [errorMessage, setErrorMessage] = useState();

      useEffect(() => {
         // Used for getting the errorMessage when NumberInput component is used as a FieldArray Field
         const nameParts = props.field.name.split(/\]\.|\.|\[|\]/);

         let errorPtr = props.form.errors;

         if (errorPtr) {
            for (let i = 0; i < nameParts.length; i++) {
               const name = nameParts[i];
               if (lodash.isObject(errorPtr)) {
                  errorPtr = errorPtr[name];
               } else {
                  break;
               }
            }
         }

         if (typeof errorPtr === 'string' || typeof errorPtr === 'undefined') {
            setErrorMessage(errorPtr);
         }
      }, [JSON.stringify(props.form.errors)]);

      const onChangeNonEvent = useCallback((newInputValue) => {
         props.form.setFieldValue(props.field.name, newInputValue);
      }, []);

      return (
         <EmailInputComponent
            { ...props.field }
            onChangeNonEvent={ onChangeNonEvent }
            isDisabled={ props.isDisabled }
            isTouched={ props.form.touched[props.field.name] }
            errorMessage={ errorMessage }
            bsSize={props.bsSize}
            placeholder={props.placeholder}
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.objectOf(PropTypes.any).isRequired,
         errors: PropTypes.objectOf(PropTypes.any).isRequired,
         setFieldValue: PropTypes.func.isRequired,
      }).isRequired,
      isDisabled: PropTypes.bool,
      bsSize: PropTypes.string,
      placeholder: PropTypes.string,
   };

   WrappedComponent.defaultProps = {
      isDisabled: false,
      bsSize: 'sm',
      placeholder: 'Enter your email',
   };

   return WrappedComponent;
};

export default withEmailInput(withInputErrorMessage(EmailInput));
